import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select } from 'antd';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import { getuserdata } from '../../services/apiService';
import decodeHtml from '../../Uitiles/decodeHtml';
import { debugLog } from '../../utils/debug';

const AddServices = ({ closeModal, getServices }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [specialities, setSpecialities] = useState([]);
    const [selectedSpeciality, setSelectedSpeciality] = useState(null);
    const [usertype, setUsertype] = useState('');
    const [manualImage, setManualImage] = useState(null);

    useEffect(() => {
        getSpecialities();
    }, []);

    const getSpecialities = async () => {
        try {
            const tableSchema = '';
            const tableName = 'specialities';
            const conditions = {};
            const orderBy = '';
            const search = '';
            const pagination = '';
            
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination);
            debugLog('getSpecialities response', response);
            setSpecialities(response.data);
            const usertype = await getuserdata('user_type');
            setUsertype(usertype);
        } catch (error) {
            console.error('Error fetching specialities:', error);
            message.error('Failed to fetch specialities');
        }
    }

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const tableSchema = '';
            const tableName = 'services';
            
            // Upload image if selected
            let fileId = '';
            const file = manualImage;
            if (file) {
                const root = 'services';
                const status = 'publish';
                
                const uploadResponse = await OneKlicksFileSDK.uploadFile(root, status, file);
                fileId = uploadResponse.fileId;
                debugLog('fileId', fileId);
            }

            const serviceData = {
                name: values.name,
                slug: values.name.toLowerCase().replace(/\s+/g, '-'),
                color: values.color || '',
                url: fileId,
                status: 'publish',
                speciality_id: values.speciality
            };

            const response = await oneKlicks.create(tableSchema, tableName, serviceData, {});
            
            if (response && response.success) {
                message.success('Service added successfully');
                form.resetFields();
                setImagePreview(null);
                closeModal();
                getServices();
            } else {
                message.error('Failed to add service');
            }
        } catch (error) {
            console.error('Error adding service:', error);
            message.error('Failed to add service');
        } finally {
            setLoading(false);
        }
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/') && file.size <= 2 * 1024 * 1024) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
                setManualImage(file);
            };
            reader.readAsDataURL(file);
        } else {
            alert('Please upload a valid image (max 2MB).');
        }
    };


    return (
        <Modal
            title="Add New Service"
            open={true}
            onCancel={closeModal}
            footer={null}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Form.Item
                    name="speciality"
                    label="Speciality"
                    rules={[{ required: true, message: 'Please select speciality' }]}
                >
                    <Select 
                        placeholder="Select speciality" 
                        options={specialities.map(speciality => ({ label: decodeHtml(speciality.name), value: speciality.id }))}
                        showSearch
                        value={selectedSpeciality}
                        onChange={(value) => {
                            setSelectedSpeciality(value);
                        }}
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        style={{ width: '100%', height: '50px' }}
                    />
                </Form.Item>

                <Form.Item
                    name="name"
                    label="Service Name"
                    rules={[{ required: true, message: 'Please enter service name' }]}
                >
                    <Input placeholder="Enter service name" />
                </Form.Item>

                <Form.Item
                    name="color"
                    label="Color"
                >
                    <Input type="color" />
                </Form.Item>

                <Form.Item
                    label="Service Image"
                >
                    <Input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                    {imagePreview && (
                        <div style={{ marginTop: '10px' }}>
                            <img
                                src={imagePreview}
                                alt="Preview"
                                style={{ maxWidth: '100px', maxHeight: '100px' }}
                            />
                        </div>
                    )}
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Add Service
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddServices; 
